/*
 * File: UIFab.js
 * Project: mp-mobile-app
 *
 * Created by Jennifer Loecker on 09/13/2019
 *
 * Copyright (c) 2019 MacPractice, Inc. All rights reserved.
 *
 * Description: Creates a fab button in the lower right of the screen
 */

import React from "react";
import { makeStyles } from "@material-ui/core/styles";
import Fab from "@material-ui/core/Fab";
import Tooltip from "@material-ui/core/Tooltip";
import PropTypes from "prop-types";

const useStyles = makeStyles(theme => ({
  fab: {
    position: "fixed",
    bottom: theme.spacing(2),
    right: theme.spacing(3),
    zIndex: 1102,
    padding: 0,
    color: theme.palette.common.white,
    backgroundColor: theme.palette.primary.main
  }
}));

const UIFab = props => {
  const classes = useStyles();
  let fabCSS = classes.fab;
  if (props.fabClassName) {
    fabCSS = [classes.fab, props.fabClassName].join(" ");
  }

  return (
    <div>
      <Tooltip title={props.name}>
        <Fab className={fabCSS} onClick={props.handleClick}>
          {props.icon}
        </Fab>
      </Tooltip>
    </div>
  );
};

UIFab.propTypes = {
  fabClassName: PropTypes.string,
  handleClick: PropTypes.func.isRequired,
  name: PropTypes.string.isRequired,
  icon: PropTypes.object.isRequired
};
export default UIFab;
